import React, { useEffect, useRef } from 'react';

import { IPlansList20Fields } from '../../../types/contentful';

import { CollapsiblePlanInfo } from './CollapsiblePlanInfo';
import { ScrollReveal } from '../ScrollReveal';

interface Props extends IPlansList20Fields {
  sysId?: string;
}

export function CollapsiblePlansList({ plans, heading, sysId }: Props) {
  const collapsiblePlanRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const setMinHeight = () => {
      collapsiblePlanRefs.current.forEach((ref) => {
        ref!.style.minHeight = 'fit-content';
      });
      const maxHeight =
        Math.max(
          ...collapsiblePlanRefs.current.map((ref) => ref?.clientHeight || 0)
        ) + 'px';

      collapsiblePlanRefs.current.forEach((ref) => {
        if (ref) ref.style.minHeight = maxHeight;
      });
    };

    setMinHeight();

    window.addEventListener('resize', setMinHeight);
    return () => window.removeEventListener('resize', setMinHeight);
  }, [plans]);

  return (
    <ScrollReveal>
      <div
        className="block-container mb-12 mt-12 tablet:mb-16 tablet:mt-16"
        data-blockid={sysId}
        data-eltype="collapsible-plans-list"
        data-testid="collapsiblePlansList"
      >
        <div className="layout -mx-2 tablet:-mx-3 desktop:-mx-4 [&>*]:px-2 tablet:[&>*]:px-3 desktop:[&>*]:px-4">
          {!!heading && (
            <div className="mb-16 box-border flex w-11/12 shrink-0 grow-0 justify-center">
              <h2
                className="typography-display-2 text-center"
                data-elementid="collapsible-plans-heading"
              >
                {heading || ''}
              </h2>
            </div>
          )}
          <div className="grid auto-rows-max small:grid-cols-1 small:gap-4 small:!px-6 tablet:grid-cols-3 tablet:gap-8">
            {(plans || []).map(({ sys, fields }, index) => (
              <CollapsiblePlanInfo
                ref={(el) => {
                  collapsiblePlanRefs.current[index] = el;
                }}
                key={sys?.id}
                {...fields}
              />
            ))}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
